import { DateRangeElement } from "@portal/BaseComponents/Filters/Elements/DateRange/DateRangeElement";
import { getDateRangeText } from "@portal/BaseComponents/Filters/Elements/DateRange/utils";
import { FilterDropdownDown } from "@portal/BaseComponents/Filters/FilterDropdown/FilterDropdownDown";
import { useFormats } from "@portal/hooks/use-formats";
import useOpen from "@portal/hooks/useOpen";
import { documentFiltersAtom } from "@portal/store/Filters/documents/document-filter";
import { resetPage, tableAtom } from "@portal/store/table/table";
import produce from "immer";
import { useAtom, useSetAtom } from "jotai";

function AddedOnFilter() {
  const { onClose, open, toggleOpen, handleOpenChange } = useOpen({
    open: false,
  });
  const setTable = useSetAtom(tableAtom);
  const [documentFilters, setDocumentFilters] = useAtom(documentFiltersAtom);
  const { dateformat } = useFormats();
  function handleHideReset() {
    return Object.values({
      from: documentFilters.filterValues.from_date,
      to: documentFilters.filterValues.to_date,
      type: documentFilters.filterValues.date_range,
    }).includes(undefined);
  }
  const Content = (
    <DateRangeElement
      value={{
        from: documentFilters.filterValues.from_date,
        to: documentFilters.filterValues.to_date,
        type: documentFilters.filterValues.date_range,
      }}
      onSubmit={(value) => {
        setDocumentFilters((filter) => {
          return produce(filter, (draft) => {
            draft.filterValues.from_date = value.from;
            draft.filterValues.to_date = value.to;
            draft.filterValues.date_range = value.type;
            return draft;
          });
        });
        onClose();
        setTable(resetPage);
      }}
      onCancel={onClose}
    />
  );

  function handleReset() {
    setDocumentFilters((filter) => {
      return produce(filter, (draft) => {
        draft.filterValues.from_date = undefined;
        draft.filterValues.to_date = undefined;
        draft.filterValues.date_range = undefined;
        return draft;
      });
    });
  }
  const hideReset = handleHideReset();
  return (
    <FilterDropdownDown
      filterBlockProps={{
        isDefault: true,
        toggleOpen,
        open,
        title: "Added on",
        filterValues: getDateRangeText(
          {
            from: documentFilters.filterValues.from_date,
            to: documentFilters.filterValues.to_date,
            type: documentFilters.filterValues.date_range,
          },
          dateformat
        ),
        onReset: handleReset,
        hideReset,
      }}
      filterComponent={Content}
      filterTitle={"Added on"}
      onopenChange={handleOpenChange}
    />
  );
}

export { AddedOnFilter };
